import React, { useCallback } from 'react';
import styled from 'styled-components';

type CheckboxContainerProps = {
	checked?: boolean;
};

const CheckboxContainer = styled.div<CheckboxContainerProps>`
	width: 20px;
	height: 20px;
	min-width: 20px;
	min-height: 20px;
	border: 2px solid #ccc;
	cursor: pointer;
	transition: background-color 0.2s ease-in-out;
	background-color: ${(props) => (props.checked ? '#e60000' : 'transparent')};
`;

type CheckboxProps = {
	checked?: boolean;
	onCheckedChange?: (checked: boolean) => void;
};

const Checkbox: React.FC<CheckboxProps> = ({ checked, onCheckedChange }) => {
	const onClick = useCallback(() => {
		if (onCheckedChange) {
			onCheckedChange(!checked);
		}
	}, [checked, onCheckedChange]);

	const className = ['checkbox'];
	if (checked) {
		className.push('checked');
	}

	return <CheckboxContainer checked={checked} onClick={onClick} className={className.join(' ')} />;
};

export default Checkbox;
